




import Vue from 'vue';
import Auth from '@/shared/auth';

export default Vue.extend({
  name: 'OidcCallback',
  async created () {
    const url = await Auth.signInRedirect();
    if (url) {
      this.$router.push(url);
    } else {
      this.$router.push('/');
      alert('Something went wrong');
    }
  }
});
